import React from 'react';

function NewOrgRow({ newRow, nrIdx, onChangeNew }) {
    return (
        <li className='row newRow'>
            <ul>
                <li className='col name'>
                    <div className='inputArea'>
                        <input name={"name"} value={newRow.name} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col nameEng'>
                    <div className='inputArea'>
                        <input name={"nameEng"} value={newRow.nameEng} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col nameIncharge'>
                    <div className='inputArea'>
                        <input name={"nameIncharge"} value={newRow.nameIncharge ?? ''} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col telIncharge'>
                    <div className='inputArea'>
                        <input name={"telIncharge"} value={newRow.telIncharge ?? ''} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col mailIncharge'>
                    <div className='inputArea'>
                        <input name={"mailIncharge"} value={newRow.mailIncharge ?? ''} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col topicOrg'>
                    <div className='inputArea'>
                        <input name={"topicOrg"} value={newRow.topicOrg ?? ''} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col comment'>
                    <div className='inputArea'>
                        <input name={"comment"} value={newRow.comment ?? ''} onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
            </ul>
        </li>
    );
}

export default NewOrgRow;